// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2ViEn","amount":"Amount_amount__1lV3V","tip":"Amount_tip__WLJh6","tipHeader":"Amount_tipHeader__36vWr","tipsWrap":"Amount_tipsWrap__1oxBZ"};